'use client';

import { PaperPlaneTilt } from 'phosphor-react';
import { cn, pushGTMEvent } from '@/lib/utils';
import { useTranslations } from '@/app/providers';

export function RotatingContactButton() {
  const t = useTranslations();
  const text = (t.nav.contactUs || 'CONTATTACI').toUpperCase();

  const handleClick = () => {
    pushGTMEvent('click_cta_contact', {
      cta_type: 'contact',
      cta_location: 'how_we_do_it_section',
    });

    const contactSection = document.getElementById('contatti');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <button
      onClick={handleClick}
      className={cn(
        'relative w-[120px] h-[120px] md:w-[170px] md:h-[170px] rounded-full cursor-pointer',
        'bg-brand-blue border-2 border-brand-violet-400',
        'text-white font-medium',
        'button-primary-shadow hover:button-primary-shadow-hover',
        'hover:border-brand-violet-300',
        'transition-all duration-0',
        'disabled:pointer-events-none disabled:opacity-50',
        'outline-none focus-visible:ring-ring/50 focus-visible:ring-[3px]',
        'flex items-center justify-center',
        'overflow-visible'
      )}
      aria-label={text}
    >
      {/* SVG per mobile */}
      <svg
        className='absolute inset-0 w-full h-full rotating-text-svg md:hidden'
        viewBox='0 0 120 120'
        preserveAspectRatio='xMidYMid meet'
      >
        <defs>
          <path id='circle-path-mobile' d='M 60,60 m -44,0 a 44,44 0 1,1 88,0 a 44,44 0 1,1 -88,0' />
        </defs>
        {[0, 1, 2].map((index) => (
          <text key={index} className='fill-white text-xs font-medium tracking-[0.05em]'>
            <textPath href='#circle-path-mobile' startOffset={`${(index * 100) / 3}%`}>
              {text}
            </textPath>
          </text>
        ))}
      </svg>

      {/* SVG per desktop */}
      <svg
        className='absolute inset-0 w-full h-full rotating-text-svg hidden md:block'
        viewBox='0 0 170 170'
        preserveAspectRatio='xMidYMid meet'
      >
        <defs>
          <path id='circle-path-desktop' d='M 85,85 m -62,0 a 62,62 0 1,1 124,0 a 62,62 0 1,1 -124,0' />
        </defs>
        {[0, 1, 2].map((index) => (
          <text key={index} className='fill-white text-sm font-medium tracking-[0.05em]'>
            <textPath href='#circle-path-desktop' startOffset={`${(index * 100) / 3}%`}>
              {text}
            </textPath>
          </text>
        ))}
      </svg>

      <div className='relative z-10'>
        <PaperPlaneTilt className='w-[38.4px] h-[38.4px] md:w-14 md:h-14' aria-hidden='true' />
      </div>
    </button>
  );
}
